var map = {
	"./Bookstore.png": 3668,
	"./Catalog.png": 5719,
	"./Crypto.png": 8961,
	"./Leaderboard.png": 178,
	"./Math-magic.png": 7800,
	"./Pokedex.png": 2943,
	"./Quizzical.png": 5505,
	"./Recipe.png": 2849,
	"./SpaceTravelers.png": 5576,
	"./Thumbs.db": 6635,
	"./Trackerbudget.png": 8039,
	"./Wheel-Wizard.png": 4134,
	"./home.jpg": 3834,
	"./inicio.png": 7109,
	"./portfolio.png": 1022,
	"./proyecto-10-com.png": 6325,
	"./proyecto-10.jpg": 5280,
	"./proyecto-11-com.png": 1801,
	"./proyecto-11.jpg": 6263,
	"./proyecto-12-com.png": 7661,
	"./proyecto-12.jpg": 8159,
	"./proyecto-13-com.png": 7270,
	"./proyecto-13.jpg": 3447,
	"./proyecto-14-com.png": 1415,
	"./proyecto-14.jpg": 9116,
	"./proyecto-15-com.png": 4681,
	"./proyecto-15.jpg": 9922,
	"./proyecto-16-com.png": 9155,
	"./proyecto-16.jpg": 2874,
	"./proyecto-17-com.png": 9126,
	"./proyecto-17.jpg": 8720,
	"./proyecto-3.jpg": 7426,
	"./proyecto-5-com.png": 3790,
	"./proyecto-5.jpg": 9270,
	"./proyecto-6-com.png": 6540,
	"./proyecto-6.jpg": 3636,
	"./proyecto-7-com.png": 3157,
	"./proyecto-7.jpg": 8779,
	"./proyecto-8-com.png": 3820,
	"./proyecto-8.jpg": 8227,
	"./proyecto-9-com.png": 7059,
	"./proyecto-9.jpg": 6253,
	"./proyecto-app-1.jpg": 3110,
	"./proyecto-app-10.jpg": 2357,
	"./proyecto-app-11.jpg": 5196,
	"./proyecto-app-12.jpg": 718,
	"./proyecto-app-13.jpg": 5956,
	"./proyecto-app-14.jpg": 9362,
	"./proyecto-app-15.jpg": 3230,
	"./proyecto-app-16.jpg": 941,
	"./proyecto-app-17-com.png": 9114,
	"./proyecto-app-17.png": 7379,
	"./proyecto-app-18-com.png": 9432,
	"./proyecto-app-18.png": 9610,
	"./proyecto-app-2.jpg": 782,
	"./proyecto-app-3.jpg": 8558,
	"./proyecto-app-4.jpg": 15,
	"./proyecto-app-5.jpg": 5886,
	"./proyecto-app-6.jpg": 2866,
	"./proyecto-app-7.jpg": 8309,
	"./proyecto-app-8.jpg": 5057,
	"./proyecto-app-9.jpg": 8748,
	"./proyecto-game-1.jpg": 8372,
	"./proyecto-game-2.jpg": 4165,
	"./proyecto-game-3.jpg": 1133,
	"./proyecto-game-4.jpg": 1617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;